import React, { ComponentType } from 'react';
import { CSSTransition } from 'react-transition-group';


export type TransitionComponentProps = {
    timeout: number;
    in?: boolean;
    keepInDOM?: boolean;
    onEntered?: (node: HTMLElement) => void;
};

export const TransitionComponent: ComponentType<TransitionComponentProps> = ({
    timeout,
    keepInDOM,
    ...props
}) => (
    // @ts-ignore
    <CSSTransition
        timeout={{
            enter: timeout * 1.1,
            exit: timeout,
        }}
        classNames={{
            enter: 'before-showing',
            enterActive: 'showing',
            enterDone: 'visible',
            exit: 'hiding',
        }}
        mountOnEnter={!keepInDOM}
        unmountOnExit={!keepInDOM}
        {...props}
    />
);

export { TransitionGroup, Transition } from 'react-transition-group';
